export var NativeStreamCastOverflowAction;
(function (NativeStreamCastOverflowAction) {
    NativeStreamCastOverflowAction["NATIVE_STREAM_CAST_OVERFLOW_ACTION_UNSPECIFIED"] = "NATIVE_STREAM_CAST_OVERFLOW_ACTION_UNSPECIFIED";
    NativeStreamCastOverflowAction["NATIVE_STREAM_CAST_OVERFLOW_ACTION_NULL"] = "NULL";
    NativeStreamCastOverflowAction["NATIVE_STREAM_CAST_OVERFLOW_ACTION_DLQ"] = "DLQ";
})(NativeStreamCastOverflowAction || (NativeStreamCastOverflowAction = {}));
